(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
  /* countdown timer daily */
  function isValidDate(d) {
    return d instanceof Date && !isNaN(d);
  }
  // Add before 0 of hour, min, sec
  function format(num) {
      return ("0" + parseInt(num)).substr(-2);
  }

  const countDownTimer = document.querySelectorAll('.countdown-daily');
  if (countDownTimer) {
    countDownTimer.forEach((countdown) => {
      const countDownWrapper = countdown.querySelector('.countdown-wrapper');
      const enableDaily = countDownWrapper.getAttribute('data-daily');
      const untilDay = new Date(countDownWrapper.getAttribute('data-until-day'));
      const dailyUntil = new Date(countDownWrapper.getAttribute('data-daily-until'));

      var x = setInterval(function time(){
        if (!isValidDate(untilDay)) {
          var start = new Date;
          start.setHours(0, 0, 0);
        } else {
          var start = untilDay;
        }

        var now = new Date;
        if (enableDaily == 'true' && now > start) {
          start.setDate(start.getDate() + 1);
        } else if (isValidDate(dailyUntil) && dailyUntil >= now && now > start) {
          start.setDate(start.getDate() + 1);
        }

        var distance = (start.getTime() - now.getTime());
        if (distance <= 0) {
          var days, hours, mins, secs;
          days = hours = mins = secs = 0;
        } else {
          var days = format(Math.floor(distance / (1000 * 60 * 60 * 24)));
          var hours = format(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
          var mins = format(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
          var secs = format(Math.floor((distance % (1000 * 60)) / 1000));
        }

        const textDay = countDownWrapper.getAttribute('data-text-day');
        const textHour = countDownWrapper.getAttribute('data-text-hour');
        const textMin = countDownWrapper.getAttribute('data-text-min');
        const textSec = countDownWrapper.getAttribute('data-text-sec');

        countDownWrapper.innerHTML = '<div><span class="number-countdown day">' + days + '</span><span class="text-countdown text-day">'+ textDay +'</span></div>'  +
                                      '<div><span class="number-countdown hours">'+hours+'</span><span class="text-countdown text-hour">'+ textHour +'</span></div>' +
                                      '<div><span class="number-countdown minutes">'+mins+'</span><span class="text-countdown text-min">'+ textMin +'</span></div>' +
                                      '<div><span class="number-countdown secs">'+secs+'</span><span class="text-countdown text-sec">'+ textSec +'</span></div>';
        if (distance <= 0) {
          clearInterval(x);
        }
      }, 1000);
    })
  }
  /* end countdown timer daily */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
      theme.initUniformHeightMonitor(productRecommendationsSection, '.product-block__image-container', '.product-block__image-container .image-one');
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.destroyUniformHeightMonitor($('.product-recommendations', event.target));
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-collection"] && !Shopify.designMode) return;
  try {
    
  
  class ProductTabMenu extends HTMLElement {
    constructor() {
      super();
      this.tabWidth();
      window.addEventListener('resize', () => {
        this.tabWidth();
      });
      this.querySelectorAll(".nav-tabs li").forEach((tab) => tab.addEventListener('click', this.tabActive.bind(this)));
    }
  
    tabActive() {
      
      event.preventDefault();
      this.querySelectorAll(".nav-tabs li").forEach((tab) => tab.classList.remove('active'));
      var href = event.target.getAttribute("href");
      event.target.parentNode.classList.add("active")
      document.querySelectorAll(".tab-pane").forEach((tab) => tab.classList.remove('active'));
      document.getElementById(href.replace("#",""))?.classList.add("active");
      document.querySelectorAll(".tab-pane").forEach((tabmobile) => {
        
      tabmobile.classList.remove('active');
      if(tabmobile.getAttribute("data-id") && tabmobile.getAttribute("data-id").includes(href.replace("#",""))) {
        tabmobile.classList.add('active');
      }
    }); 
    }
    tabWidth() { 
      const widthTab = this.querySelector(".nav-tabs").offsetWidth;
      const widthTabMenu = this.querySelector(".tab-menu").offsetWidth;
      if(widthTab > widthTabMenu){
        this.querySelector(".tab-menu").classList.add('add-icon');
      }else{
        if (this.querySelector(".tab-menu").classList.contains('add-icon')) {
          this.querySelector(".tab-menu").classList.remove('add-icon');
          
        }
      }
    }
  }
  customElements.define("tab-menu", ProductTabMenu)

  } catch(e) { console.error(e); }
})();
})();
